import ComplianceQuestionAssignment from "@/components/probaworkflows_base_components/ComplianceQuestionAssignment/ComplianceQuestionAssignment.vue";
import { get_headers } from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import ongoing_compliance_checklist_mixin from "@/utils/mixins/compliance_mixins/ongoing_compliance_checklist_mixin";

export default {
  name: "ComplianceRules",
  mixins: [alert_mixin, ongoing_compliance_checklist_mixin],
  components: {
    ComplianceQuestionAssignment,
  },

  props: {
    form_id: {
      type: [String, Number],
      required: true,
    },
    form_name: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    token: null,
    headers: get_headers(),

    loading: true,
    is_creating_rule: false,
    is_deleting: false,
    is_editing: false,

    rules: [],
    rule_to_delete: null,
    countdown_data: [],

    entity_type_id: null,

    selected_rule: null,
    show_assign_modal: false,

    dataTable: null,

    createRuleModal: null,
    deleteConfirmationModal: null,

    show_create_modal: false,
    show_delete_modal: false,

    rule_form: {
      id: null,
      name: "",
      description: "",
      initial_grace_period: "",
      frequency: "",
      recurring_grace_period: "",
      entity_type: null,
      version: 1,
      initial_grace_period_days: null,
      recurring_grace_period_days: null,
      frequency_type: null,
      custom_frequency_days: null,
      logical_operator: "AND",
    },
  }),
};
